import React from 'react'

function UserAvatar({src, alt='user'}) {
  return (
    <img src={src ?? '/images/user.png'} alt={alt} />
  )
}

export default UserAvatar